<template>
  <div
    class="col-span-full items-center p-1 whitespace-nowrap text-slate-500 select-none"
  >
    <slot>
      Nothing to show here
    </slot>
  </div>
</template>
